import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';
import { Button, useMediaQuery, Box } from '@spothero/ui';
import SpotListItemBase from 'common/spot-card-base/v2';
import FacilitySummary from 'common/facility-summary/v2';
import { push as pushTo } from 'store/router/router-actions';
import { showSpotsLeft } from 'utils/spot-left';
import { setSpotDetailReferrer as setSpotDetailReferrerTo } from 'store/spot/spot-actions';
import DynamicSpotListItemButton from '../spot-card-dynamic-CTA-button';
import { FACILITY_SUMMARY_VIEW_TYPES } from 'common/facility-summary/utils';
import { useDispatch } from 'react-redux';
import { routeToSpotDetails } from 'router/router-utils';
import AirportCardTransportation from './AirportSpotTransportation';
import AirportDistance from './AirportDistance';
import useIsMobile from 'hooks/use-is-mobile';
export const buildAirportSpotTag = (tag) => {
    const MOST_POPULAR_TAG = 'Most Popular';
    // For now this is implemented in UI as we don't want to show the tag but want sorting to happen for Most Popular spots.
    // All the sorting logic will be moved to BE and this condition can be cleaned up along with the airport sorting logic.
    if (!tag || tag === MOST_POPULAR_TAG) {
        return [];
    }
    const airportTag = [
        {
            title: tag,
        },
    ];
    return airportTag;
};
export const SpotListItemAirport = ({ spot, isActive, isHighlighted, isAdmin, isRebookingReservation, updateSelectedSpot, onShowDetailsClick, onBookSpotClick, referer = 'list', optimizely, }) => {
    const dispatch = useDispatch();
    const { location } = useHistory();
    const isMobile = useIsMobile();
    const { spotId, availability, facilityType, transportation, tag } = spot;
    const { available, availableSpaces } = availability;
    const containerClasses = classNames({ 'SpotListItem-active': isActive }, { 'SpotListItem-hovered': isHighlighted }, { unavailable: !available });
    const handleShowDetailsClick = evt => {
        evt.preventDefault();
        evt.stopPropagation();
        setSpotDetailReferrerTo(referer);
        routeToSpotDetails({
            method: (...args) => dispatch(pushTo(...args)),
            location,
            spotId,
            historyState: { referrer: referer },
        });
        if (onShowDetailsClick) {
            onShowDetailsClick({ spotId });
        }
        routeToSpotDetails({
            method: (...args) => dispatch(pushTo(...args)),
            location,
            spotId,
            historyState: { referrer: referer },
        });
    };
    const handleBookSpotClick = evt => {
        evt.preventDefault();
        evt.stopPropagation();
        if (onBookSpotClick) {
            onBookSpotClick({ spotId });
        }
        updateSelectedSpot({
            spot,
            referrer: referer,
            goToSpotUrl: true,
            optimizely,
        });
    };
    const isShowSpotsLeftVisible = showSpotsLeft({
        available,
        availableSpaces,
        facilityType,
    });
    const [isDeviceSmallerThan360px] = useMediaQuery('(max-width: 360px)');
    const showImages = useMemo(() => !isDeviceSmallerThan360px, [
        isDeviceSmallerThan360px,
    ]);
    const updatedImages = [spot.logo, ...spot.images];
    return (<SpotListItemBase spotId={spotId} additionalClasses={containerClasses} onClick={handleShowDetailsClick} MainContent={<FacilitySummary 
        // @ts-ignore
        spot={{
                ...spot,
                images: updatedImages,
                visualFlags: buildAirportSpotTag(tag),
            }} showImages={showImages} isAdmin={isAdmin} isShowSpotsLeftVisible={isShowSpotsLeftVisible} view={FACILITY_SUMMARY_VIEW_TYPES.SPOT_LIST} AirportDistance={<AirportDistance spot={spot}/>} AirportTransportationInfo={<AirportCardTransportation type={transportation?.type || ''}/>} CTAs={<Box paddingTop="3" {...(isMobile && { display: 'flex' })}>
                            <Button variant="tertiary" onClick={handleShowDetailsClick} data-testid="AirportCard-view-details" display={!available ? 'none' : 'inline-flex'}>
                                Details
                            </Button>

                            <DynamicSpotListItemButton isAdmin={isAdmin} available={available} isRebookingReservation={isRebookingReservation} isHovered={isHighlighted} onClick={handleBookSpotClick} isAirport/>
                        </Box>}/>}/>);
};
export default React.memo(SpotListItemAirport);
